import type { ReactElement } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Box } from '@mui/material';

import { Popup } from '@/components/common/Popup';
import { useIsPhoneOrHighScreen } from '@/shared/hooks/useIsPhoneOrHighScreen';
import { AppErrorBoundary } from '@/shared/ui/app-error-boundary/AppErrorBoundary';

import { userKeys } from '../../api/userQueryKeys';
import { UserAccessControlRoutes } from './UserAccessControlRoutes';

type UserAccessControlPopupFrameProps = {
  closePopup: () => Promise<void>;
  children: ReactElement;
};

type UserAccessControlPopupProps = {
  closePopup: () => Promise<void>;
  'data-qa-element-id'?: string;
};

function UserAccessControlPopupFrame({ closePopup, children }: UserAccessControlPopupFrameProps) {
  const isPhone = useIsPhoneOrHighScreen();

  if (isPhone) {
    return <Popup body={children} closePopup={closePopup} isFullScr={true} showCloseButton={false} leftText={true} />;
  }

  return children;
}

export default function UserAccessControlPopup({
  closePopup,
  'data-qa-element-id': dataQaElementId,
}: UserAccessControlPopupProps) {
  const queryClient = useQueryClient();

  function handleReset() {
    void queryClient.invalidateQueries({ queryKey: userKeys.lists() });
  }

  return (
    <AppErrorBoundary boundaryId="user-access-control" onReset={handleReset}>
      <Box data-qa-element-id={dataQaElementId} width="100%" height="100%" minHeight={0}>
        <UserAccessControlPopupFrame closePopup={closePopup}>
          <UserAccessControlRoutes />
        </UserAccessControlPopupFrame>
      </Box>
    </AppErrorBoundary>
  );
}
